import * as React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from 'react-router-dom';
import App from "./App.tsx";
import "./index.css";
import "./components/ui/select-improvement.css";

// Initialize Sentry monitoring (production only)
import './lib/sentry';

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Failed to find the root element");
}

try {
  createRoot(rootElement).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
} catch (error) {
  console.error("Failed to render app:", error);
  // Fallback display
  rootElement.innerHTML = `
    <div style="padding: 20px; text-align: center;">
      <h1>Erreur de chargement</h1>
      <p>L'application n'a pas pu démarrer. Veuillez rafraîchir la page.</p>
      <pre style="text-align: left; background: #f5f5f5; padding: 10px; margin-top: 20px;">${error}</pre>
    </div>
  `;
}
